<div class="agenx-login">
  <agenx-auth [user]="userAuth" [password]="passwordAuth"
    [error]="error" (login)="authentication($event)" [state_button]="state_button"></agenx-auth>
</div>
